import { IeLynxObject } from "../../common/models/eLynxObject";

export enum AttributeSchemaTypeEnum {
    None = 0,
    Date = 1,
    Numeric = 2,
    FreeformText = 3,
    PredefinedValue = 4,
    PredefinedValueAndFreeformText = 5
}


export interface IAttributeValueOptionDto {

    id: number;
    asid: number;
    cuid: number;
    cdto: Date;
    muid: number;
    mdto: Date;
    val: string;
    ord: number;
    //deleted: boolean;
    //added: boolean;
    //updated: boolean;
}


export interface IAttributeSchema {
    id: number;
    cuid: number;
    cdto: Date;
    muid: number | undefined;
    mdto: Date | undefined;

    dd: number;
    // Used for the Attribute Schema Name and for the Attribute Name
    //  when applying the attribute.
    name: string;
    stype: AttributeSchemaTypeEnum;
    vopts: Array<IAttributeValueOptionDto> | undefined;
    wd: number | undefined;
}


// public class AttributeValueOption2
// {
//     #region Properties

//     [JsonProperty("id")]
//     public int? ID { get; set; }
//     [JsonProperty("asid")]
//     public int? AttributeSchemaID { get; set; }
//     [JsonProperty("cuid")]
//     public int? CreatedBy { get; set; }
//     [JsonProperty("cdto")]
//     public DateTimeOffset? Created { get; set; }
//     [JsonProperty("muid")]
//     public int? ModifiedBy { get; set; }
//     [JsonProperty("mdto")]
//     public DateTimeOffset? Modified { get; set; }
//     [JsonProperty("val")]
//     public string Value { get; set; }
//     [JsonProperty("ord")]
//     public int Order { get; set; }

//     [JsonProperty("added")]
//     public bool Added { get; set; }
//     [JsonProperty("deleted")]
//     public bool Deleted { get; set; }
//     [JsonProperty("updated")]
//     public bool Updated { get; set; }


// public class AttributeSchema
// {
//     #region Properties

//     [JsonProperty("id")]
//     public int? ID { get; set; }
//     [JsonProperty("cuid")]
//     public int? CreatedBy { get; set; }
//     [JsonProperty("cdto")]
//     public DateTimeOffset? Created { get; set; }
//     [JsonProperty("dd")]
//     public int DecimalDigits { get; set; } = 0;
//     [JsonProperty("muid")]
//     public int? ModifiedBy { get; set; }
//     [JsonProperty("mdto")]
//     public DateTimeOffset? Modified { get; set; }
    
//     // Used for the Attribute Schema Name and for the Attribute Name
//     //  when applying the attribute.
//     [JsonProperty("name")]
//     public string Name { get; set; }
//     [JsonProperty("stype")]
//     public AttributeSchemaTypeEnum SchemaType { get; set; }
//     [JsonProperty("vopts")]
//     public List<AttributeValueOption2> ValueOptions { get; set; }
//     [JsonProperty("wd")]
//     public int? WholeDigits { get; set; }

//     [JsonProperty("ag")]
//     public bool AllowGroupBy { get; set; }


export interface IAttributeValueOption {
    id: number;
    schemaID: number;
    value: string;
    order: number;

    createdBy?: number;
    created?: Date;
    modifiedBy?: number;
    modified?: Date;

    //     id: number;
    //     schemaID: number;
    //     value: string;
    //     order: number;
    deleted: boolean;
    added: boolean;
    updated: boolean;
    
    //     createdBy?: number;
    //     created?: Date;
    //     modifiedBy?: number;
    //     modified?: Date;
    
    //     // Likely will not uses these in this app
    //     // UI Only
    //     //errorMessage?: string;
    //     //isSelected: boolean;
    //     //isValid: boolean;
    
    //     //fromDTO?(dto?: IAttributeValueOptionDto): AttributeValueOption2;
    //     //toDTO?(): IAttributeValueOptionDto;
    // }
}    

export interface IAttributeSchemaModel {
    id: number;
    createdBy?: number;
    created?: Date;
    decimalDigits?: number;
    modifiedBy?: number;
    modified?: Date;
    name: string;
    schemaType: AttributeSchemaTypeEnum;
    valueOptions: IAttributeValueOption[];
    wholeDigits?: number;
    allowGroupBy: boolean;
}


const defaultAttributeSchema: IAttributeSchemaModel = {
    id: 0,
    name: '',
    schemaType: AttributeSchemaTypeEnum.None,
    valueOptions: [],
    allowGroupBy: false,
    decimalDigits: 0,
    wholeDigits: 99
}

export {defaultAttributeSchema};




// this maps to AttributeDto in core, not sure how we have this here
export interface IAttribute {

    // Attribute ID
    aid: number;
    // Object Display Text
    odt: string;
    // Object Type
    ot: number;
    // Object ID
    oid: number;
    // Attribute Name
    an: string;
    // Attribute Value
    av: string;

    // Attribute External flag
    ext: boolean;
    // Attribute Schema ID
    asid: number;
    // Attribute Schema
    attrs?: IAttributeSchema;


    // Likely will not uses these in this app        
    added?: boolean;
    deleted?: boolean;
    // renamed: boolean;

    selected?: boolean;
    // originally selected
    oselected?: boolean;

    updated?: boolean;
    // valid: boolean;
    
    // // UI Only
    // // Value Option ID
    voptid?: number;
    // fromDTO?(dto?: IAttributeDto): Attribute;
    // toDTO?(): IAttributeDto;

    avdate?: Date | null;

    avalt?: string;

    // original values
    oav?: string;
    oavdate?: Date | null;
}


export interface IAttributeModel {
    id: number;
    // We do not need this for ScadaLynx. The routes determine the objectType, objectID, and security.
    object: IeLynxObject;
    attributeName: string;
    attributeValue: string;
    attributeValues: string[];
    // we do not need this for SCADALynx. Only external are allowed.
    isExternal: boolean;
    // // these are only for the client
    // isDeleted: boolean;
    // isModified: boolean;
    // isSelected: boolean;
    attributeSchemaID?: number;
}

export interface IObjectAttributeValue {
    object: IeLynxObject;
    value: string;
}


export interface IAttributeUsage
{

    // Attribute Name / Attribute Schma Name
    attributeName: string;

    // Attribute Schema ID
    attributeSchemaID: number | undefined;

    // Objects with the Attribute Values
    objectAttributeValues: IObjectAttributeValue[];

    // Device Usage Count
    deviceUsageCount: number;

    // Device Value Count
    deviceValueCount: number;

    // Tank Usage Count
    tankUsageCount: number;

    // Tank Value Count
    tankValueCount: number;

    // Tank Battery Usage Count
    tankBatteryUsageCount: number;

    // Tank Battery Value Count
    tankBatteryValueCount: number;

    // Well Usage Count
    wellUsageCount: number;

    // Well Value Count
    wellValueCount: number;

    // Total Usage Count
    totalUsageCount: number;
}

// export interface IAttributeUsagex {

//     // Attribute Name / Attribute Schma Name
//     an: string;
//     // Attribute Schema ID
//     asid: number;

//     // Objects with the Attribute Values
//     oavs: Array<IObjectAttributeValue>;

//     // Device Usage Count
//     duc: number;
//     // Device Value Count
//     dvc: number;

//     // Tank Usage Count
//     tkuc: number;
//     // Tank Value Count
//     tkvc: number;

//     // Tank Battery Usage Count
//     tkbuc: number;
//     // Tank Battery Value Count
//     tkbvc: number;

//     // Well Usage Count
//     wuc: number;
//     // Well Value Count
//     wvc: number;
//     // Total Usage Count
//     tuc: number;

//     // UI Only
//     usageExpanded: boolean;
//     usageRetrievalState: RetrievalState;
//     deviceObjects: Array<IObjectAttributeValue>;
//     devUsageExpanded: boolean;
//     tankObjects: Array<IObjectAttributeValue>;
//     tankUsageExpanded: boolean;
//     tankBatteryObjects: Array<IObjectAttributeValue>;
//     tankBatteryUsageExpanded: boolean;
//     wellObjects: Array<IObjectAttributeValue>;
//     wellUsageExpanded: boolean;
//     visible?: boolean;
//}


export interface IObjectAttributes
{
    devices: IAttribute[];
    groups: IAttribute[];
    tanks: IAttribute[];
    tankBatteries: IAttribute[];
    wells: IAttribute[];
}

export const TANK_BATTERY_ALTERNATE_PRESENTATION = "Tank Battery Details Alternate Presentation";

